import { AxiosInstance } from 'axios';
import { getScimConfig } from '../utils/envUtils';
import { ScimAuthService } from './ScimAuthService';
import { createAxiosInstance } from './axiosInstance';
import { SchemaEntityResponse, SchemaAttributeResponse } from '../types/SchemaTypes';
export class ScimSchemaService {
    private api: AxiosInstance;
    private baseUrl: string;

    constructor() {

        // Get SCIM API configuration from environment variables
        const scimConfig = getScimConfig();
        this.baseUrl = scimConfig.apiUrl;

        // Use axios instance with interceptors for automatic token refresh and 401 retry
        this.api = createAxiosInstance(this.baseUrl);
    }


    /**
     * Get schema entities. DISABLED: no API call; entity types are driven by tier1 entitlements.
     * Returns empty response so callers do not break.
     */
    async getSchemaEntities(): Promise<SchemaEntityResponse> {
        return {
            Resources: [],
            totalResults: 0,
            itemsPerPage: 0,
            startIndex: 0,
            schemas: []
        };
    }

    /**
     * Get schema attributes. DISABLED: no API call; form attributes are driven by tier2/tier3 entitlements.
     * Returns empty response so callers do not break.
     */
    async getSchemaAttributes(): Promise<SchemaAttributeResponse> {
        return {
            Resources: [],
            totalResults: 0,
            itemsPerPage: 0,
            startIndex: 0,
            schemas: []
        };
    }

    /**
     * Get a single schema attribute by ID. DISABLED: no schema attribute API calls.
     * Returns null so callers get no attribute metadata (use tier2/tier3 attributes instead).
     */
    async getSchemaAttributeById(_attributeId: string): Promise<any> {
        return null;
    }

    /**
     * Get reference attributes for a schema attribute. DISABLED: no schema attribute API calls.
     * Returns empty array so callers do not break.
     */
    async getReferenceAttributesForAttribute(_attributeId: string, _filter?: string): Promise<any[]> {
        return [];
    }
}
